import { VideoVisitBannerOneLineView } from './VideoVisitBannerOneLineView';
import { VideoVisitBannerView } from './VideoVisitBannerView';

export default VideoVisitBannerView;
export { VideoVisitBannerOneLineView };
